import React, { ReactNode } from 'react';
import { sendToSentry } from '@threatadvisor/react-utils';

type ErrorBoundaryProps = { children: ReactNode; fallback: (error: Error) => ReactNode };
type ErrorBoundaryState = { error?: Error };
export default class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {};
  }

  static getDerivedStateFromError(error: Error): Partial<ErrorBoundaryState> {
    return { error };
  }

  componentDidCatch(error: Error): void {
    sendToSentry(error);
  }

  render(): ReactNode {
    if (this.state.error) {
      return this.props.fallback(this.state.error);
    }
    return this.props.children;
  }
}
